import React, { createContext, useContext, useState, useEffect } from 'react';

const EditionContext = createContext();

export const EditionProvider = ({ children }) => {
    const [selectedEditionUp, setSelectedEditionUp] = useState(() => {
        // Recupera do localStorage se existir
        const saved = localStorage.getItem('selectedEdition');
        return saved ? JSON.parse(saved) : null;
    });

    const [refreshTrigger, setRefreshTrigger] = useState(0);


    const updateEditionUp = (edition) => {
        setSelectedEditionUp(edition);
        localStorage.setItem('selectedEdition', JSON.stringify(edition));
        setRefreshTrigger(prev => prev + 1);

    };

    return (
        <EditionContext.Provider value={{
            selectedEditionUp,
            updateEditionUp,
            refreshTrigger
        }}>
            {children}
        </EditionContext.Provider>
    );
};

export const useEdition = () => {
    return useContext(EditionContext);
};